import { AppInsights } from '@bluedolphin/util-module-mf';
import { TenantProvider } from './tenant';
import { UserProvider } from './user';
import { ApplicationProvider } from './application';
import { AzureMsalProvider } from './azure';
import { useEffect } from 'react';
import { SnackbarProvider, ThemeProvider, theme } from '@bluedolphin/ui';

const { AppInsightsProvider } = AppInsights;

/**
 * Providers composition
 *
 * @returns {JSX.Element}
 */
export function Providers({ children, customProps }): JSX.Element {
    useEffect(() => {
        const { singleSpa } = customProps;
        singleSpa.addErrorHandler((err: { appOrParcelName: string }) => {
            if (
                singleSpa.getAppStatus(err.appOrParcelName) ===
                singleSpa.LOAD_ERROR
            ) {
                AppInsights.trackEvent('micro:app:load:error', err);
                window.System.delete(
                    window.System.resolve(err.appOrParcelName)
                );
            }
        });
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <AppInsightsProvider>
                <SnackbarProvider>
                    <TenantProvider>
                        <AzureMsalProvider customProps={customProps}>
                            <UserProvider>
                                <ApplicationProvider customProps={customProps}>
                                    {children}
                                </ApplicationProvider>
                            </UserProvider>
                        </AzureMsalProvider>
                    </TenantProvider>
                </SnackbarProvider>
            </AppInsightsProvider>
        </ThemeProvider>
    );
}
